import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFlexModule } from 'ng-zorro-antd/flex';
import { NzSpinComponent } from 'ng-zorro-antd/spin';
import { UserService } from '../../services/user-service';

import { CommonModule } from '@angular/common';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { ModulesLookup } from '../../../../core/context/modules-lookup';
import { RolesLookup } from '../../../../core/context/roles-lookup';
import { ResourceService } from '../../../../core/services/resource-service';
@Component({
  selector: 'app-user-details',
  imports: [
    NzButtonModule,
    NzFlexModule,
    NzSpinComponent,
    CommonModule,
    NzCardModule,
    NzAvatarModule,
    NzTagModule,
    NzIconModule,
    RouterLink,
  ],
  templateUrl: './user-details.html',
  styleUrl: './user-details.scss',
})
export class UserDetailsComponent {
  userService = inject(UserService);
  route = inject(ActivatedRoute);
  resourceService = inject(ResourceService);

  userId = this.route.snapshot.paramMap.get('id');
  userDetails = toSignal(this.userService.get(Number(this.userId)), { initialValue: null });
  userResources = toSignal(this.resourceService.getResourceIdentityTypes(), { initialValue: [] });
  moduleNames = computed(() => {
    const companyModules = this.claims()?.modules ?? [];
    return companyModules.map((module) => ModulesLookup.modules[module] ?? module);
  });
  roleNames = computed(() => {
    const userRoles = this.userDetails()?.roles ?? [];
    return userRoles.map(
      (role) => RolesLookup.roles.find((r) => r.name === role)?.description ?? role,
    );
  });
  claims = computed(() => {
    const user = this.userDetails();

    return {
      companies: this.parseCollection(user?.claims?.['mhs.scm.companies']),
      modules: this.parseCollection(user?.claims?.['mhs.scm.modules']),
      tenants: this.parseCollection(user?.claims?.['mhs.scm.tenants']),
    };
  });
  initials = computed(() => {
    const user = this.userDetails();

    if (!user) {
      return '?';
    }

    return `${user.firstName?.[0] ?? ''}${user.lastName?.[0] ?? ''}`.toUpperCase();
  });
  identityTypeDesc = computed(() => {
    const user = this.userDetails();
    const identityType = user?.identifierType;

    if (!identityType) {
      return 'Unknown';
    }

    const resource = this.userResources().find((r) => r.name === identityType);
    return resource?.description ?? 'Unknown';
  });

  claimList(name: string): string[] {
    const value = this.userDetails()?.claims?.[name];

    if (!value) {
      return [];
    }

    return value
      .replace(/[\[\]']/g, '')
      .split(',')
      .map((x) => x.trim())
      .filter(Boolean);
  }
  parseCollection(value?: string): string[] {
    if (!value) return [];

    return value
      .replace(/[\[\]']/g, '')
      .split(',')
      .map((x) => x.trim())
      .filter(Boolean);
  }
}
